import { render, staticRenderFns } from "./EditUsersPermision.vue?vue&type=template&id=6c3a37d3&scoped=true"
import script from "./EditUsersPermision.vue?vue&type=script&lang=js"
export * from "./EditUsersPermision.vue?vue&type=script&lang=js"
import style0 from "./EditUsersPermision.vue?vue&type=style&index=0&id=6c3a37d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a37d3",
  null
  
)

export default component.exports